import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseApiTemplateService, Core2Config, ApiVisa } from '../../../shared';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../../shared/api-response.model';
import { Pagination } from '../../../shared/pagination.model';
import { PagingResponseModel } from '../../../shared/api-response.model';
@Injectable({
  providedIn: 'root'
})
export class DeliveryPlanService extends BaseApiTemplateService<any> {

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "del/delivery-plans/backoffice-ep";
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "del/delivery-plans/backoffice-ep";
        this.httpClient = http;
      }
    
      public updateLinks(payload:any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "del/delivery-plans/update-links/backoffice-ep";
        }
        return this.httpClient.put<ApiResponseModel<any>>(
          url,
          payload,
          this.getHttpHeader(visa)
        );
      }

      public createRecurring(payload:any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "del/delivery-plans/create-recurring/backoffice-ep";
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          payload,
          this.getHttpHeader(visa)
        );
      }


      public updateRecurring(payload:any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "del/delivery-plans/update-recurring/backoffice-ep";
        }
        return this.httpClient.put<ApiResponseModel<any>>(
          url,
          payload,
          this.getHttpHeader(visa)
        );
      }

      public deleteRecurring(guid:any, deleteType:any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "del/delivery-plans/delete-recurring/backoffice-ep/"+guid+"?delete_type="+deleteType;
        }
        return this.httpClient.delete<ApiResponseModel<any>>(
          url,
          this.getHttpHeader(visa)
        );
      }

      public getDeliveryPlanCalendarView(
        pagination: Pagination,
        visa: ApiVisa,
        criteria?: any,
      ): Observable<PagingResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        const UrlByCriteria =
        visa.api_domain_url +  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "del/delivery-plans/custom-event-view/backoffice-ep/query?" + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<any>>(
          UrlByCriteria,
          this.getHttpHeader(visa)
        );
      }

}